import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import potDessert from "@/assets/products/pot-dessert.png";
import potDessertNoir from "@/assets/products/pot-dessert-2.png";
import potDessertLifestyle from "@/assets/products/pot-dessert-lifestyle.png";

const config: ProductPageConfig = {
  name: "Pots à dessert",
  breadcrumbName: "Pot dessert",
  subtitle: "Pots transparents pour desserts, mousses et verrines",
  features: ["Contact alimentaire", "Transparent", "Avec couvercle", "Disponible en stock"],
  variants: [
    { name: "Pot transparent", capacity: "250 ml", material: "Plastique PET", packaging: "Carton de 500 (10 x 50)", palette: "180 cartons", image: potDessert },
    { name: "Pot couvercle noir", capacity: "250 ml", material: "Plastique PET", packaging: "Carton de 500 (10 x 50)", palette: "180 cartons", image: potDessertNoir },
  ],
  lifestyleImages: [
    { src: potDessertLifestyle, caption: "Idéal pour verrines et desserts à emporter" },
  ],
};

const PotDessert = () => <ProductPageLayout config={config} />;
export default PotDessert;
